import {
  Box,
  Button,
  Divider,
  IconButton,
  Paper,
  Typography,
} from '@mui/material';
import { useCallback } from 'react';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  BasketDiscountMetadata,
  BasketDiscountProduct,
} from '../../../interfaces/Offer/Metadata/BasketDiscount';
import { sharedStyles } from '../../../utils/Style';
import { ProductsDropdown } from '../../../components/Dropdowns/ProductsDropdown';
import NumberInput from '../../../components/NumberInput/NumberInput';

type BasketDiscountFormProps = {
  value: BasketDiscountMetadata;
  onChange: (value: BasketDiscountMetadata) => void;
  disabled?: boolean;
  minWidth: number;
  maxWidth: number;
};

export const BasketDiscountForm = (props: BasketDiscountFormProps) => {
  const onUpdate = useCallback(
    (index: number, entry: BasketDiscountProduct) => {
      const newProducts = [...props.value.products];
      newProducts[index] = entry;
      props.onChange({ ...props.value, products: newProducts });
    },
    [props.value, props.onChange],
  );

  const onDelete = useCallback(
    (index: number) => {
      const newProducts = [...props.value.products];
      newProducts.splice(index, 1);
      props.onChange({ ...props.value, products: newProducts });
    },
    [props.value, props.onChange],
  );

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        p: 3,
        flexGrow: 1,
        minWidth: props.minWidth,
        maxWidth: props.maxWidth,
      }}
    >
      <Typography
        sx={{
          ...sharedStyles.h5,
          fontWeight: 'bold',
        }}
      >
        İndirimli Ürünler
      </Typography>
      <Divider />

      {props.value.products.map((product, i) => (
        <Box key={i} sx={{ display: 'flex', flexDirection: 'row', gap: 0.5 }}>
          <Box sx={{ flex: '2 2 0' }}>
            <ProductsDropdown
              label='Ürün'
              disabled={props.disabled}
              multiple={false}
              value={product.productID}
              excludedIDs={props.value.products
                .map((x) => x.productID)
                .filter((x) => x !== product.productID)}
              onChange={(x) => {
                if (x) {
                  onUpdate(i, { ...product, productID: x });
                }
              }}
            />
          </Box>
          <Box sx={{ flex: '1 1 0' }}>
            <NumberInput
              label='İndirimli Fiyat'
              disabled={props.disabled}
              value={product.price}
              onChange={(x) => onUpdate(i, { ...product, price: x })}
              acceptFloat
              endAdornment={<Typography>₺</Typography>}
            />
          </Box>

          {!props.disabled && (
            <IconButton color='error' onClick={() => onDelete(i)} size='small'>
              <DeleteIcon />
            </IconButton>
          )}
        </Box>
      ))}

      {!props.disabled && (
        <Button
          startIcon={<AddIcon />}
          onClick={() =>
            props.onChange({
              ...props.value,
              products: [...props.value.products, { productID: 0, price: 0 }],
            })
          }
          sx={{ ...sharedStyles.buttonText }}
        >
          Ekle
        </Button>
      )}
    </Paper>
  );
};
